import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/layout/PageHero';
import { Briefcase, Mail } from 'lucide-react';

const CareersPage = () => {
  return (
    <div className="min-h-screen" data-testid="careers-page">
      <PageHero
        eyebrow="Company"
        title="Careers"
        description="Help build the automotive knowledge platform we wished existed."
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <div className="max-w-xl text-center mx-auto py-8" data-testid="careers-no-openings">
            <div className="mx-auto w-16 h-16 rounded-full bg-chassis flex items-center justify-center mb-6">
              <Briefcase className="h-7 w-7 text-autoxium-blue" />
            </div>
            <h2 className="font-chivo text-xl font-bold uppercase tracking-tight mb-2">
              No Open Roles Right Now
            </h2>
            <p className="text-muted-foreground mb-6">
              We don't have any open positions at the moment, but we're growing and that
              changes. Check back soon, or reach out if you think there's a fit —
              we still read every message.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-autoxium-blue font-medium text-sm"
              data-testid="careers-contact-link"
            >
              <Mail className="h-4 w-4" />
              Get in touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;
